import React from "react"
const token = JSON.parse(localStorage.getItem("Token"))
import { toast } from "react-toastify"
import axios from "axios"
const ReusableComponent2 = ({
  id,
  title,
  value,
  track,
  setLoading,
  setSubmit,
}) => {
  const handleUpdateStatus = async newStatus => {
    console.log("Leave Status:", newStatus)
    try {
      setLoading(true)
      setSubmit(false)
      const res = await axios({
        method: 'POST',
        url: 'https://marcopolo.prisms.in/api/LeaveList/update-leave-status',
        data: {
          leave_request_id: id,
          status: newStatus,
          status_reason: '',
        },
        headers: {
          Authorization: token,
        },
      })
      setLoading(false)
      setSubmit(true)
      toast.success(res.data.message)
    } catch (error) {
      setLoading(false)
      setSubmit(true)
      toast.error('Something went wrong')
    }
  }

  const options = [
    'Pending',
    'Approved L1',
    'Approved L2',
    'Rejected',
    'Cancelled',
  ]
  const filteredOptions = options.filter(option => option !== value)

  return (
    <div className="d-flex justify-content-between">
      <div>
        <span className="fs-5 fw-semibold text-dark">{title}</span>
      </div>
      <div>
        <select
          className="form-select"
          defaultValue={value}
          onChange={e => handleUpdateStatus(e.target.value)}
        >
          <option value={value}>{value}</option>
          {filteredOptions.map((option, index) => {
            const shouldDisable =
              (track === 'Approved L1' && option === 'Approved L2') ||
              (track === 'Approved L2' && option === 'Approved L1')
            return (
              <option key={index} value={option} disabled={shouldDisable}>
                {option}
              </option>
            )
          })}
        </select>
      </div>
    </div>
  )
}

export default ReusableComponent2